<template>
  <div class="main frame-road">
    <div class="frame-bg">
      <img
        class="frame-img"
        :class="{ zoom: startZoom }"
        src="/assets/images/frame-road.webp"
        alt
      />
      <img
        class="img-overlay"
        :class="{ shadow: hoverDoor, 'd-none': startZoom }"
        src="/assets/images/door-road.webp"
        alt
      />
      <map name="mapframe">
        <area
          shape="poly"
          coords="940,440,1000,440,1080,650,1000,710,920,720,855,670,"
          href="#"
          @click="startOut"
          @mouseover="hoverDoor = true"
          @mouseleave="hoverDoor = false"
        />
      </map>
      <img
        class="img-overlay img-front"
        src="/assets/images/map.webp"
        usemap="#mapframe"
        alt
      />
    </div>
    <div class="frame-overlay"></div>
    <!-- <leaves></leaves> -->
    <div class="frame-content container-fluid fade-in" :class="{ 'fade-out': startZoom }">
      <div class="frame-text px-4">
        <p class="text-center">
          ValhallaVerse is a Norse mythology-themed ecosystem, powered by <br />
          Avalanche Network, where players compete in PvP arenas and <br />
          go on challenging adventures that are paired with Play-and-Earn mechanics.
        </p>
        <div class="bottom-line mt-3"></div>
      </div>
    </div>
    <div
      class="enter-door"
      @mouseover="hoverDoor = true"
      @mouseleave="hoverDoor = false"
      :class="{ 'fade-out': startZoom }"
    >
      <a @click="startOut">Road to Valhalla</a>
    </div>
  </div>
</template>

<script>
import imageMapResize from "image-map-resizer";
import Leaves from "@/components/Leaves.vue";

export default {
  data() {
    return {
      hoverDoor: false,
      startZoom: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.windowResize);
    setTimeout(() => imageMapResize(), 50);

    setInterval(() => {
      if (!this.hoverDoor) {
        this.hoverDoor = true;
        setTimeout(() => (this.hoverDoor = false), 500);
      }
    }, 5000);
  },
  updated() {
    setTimeout(() => imageMapResize(), 50);
  },
  unmounted() {
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    windowResize(e) {
      console.log("res");
      imageMapResize();
    },
    startOut() {
      console.log("startOut");
      this.startZoom = true;
      setTimeout(() => this.$router.push("/inside"), 1000);
    },
  },
  components: {
    Leaves,
  },
};
</script>

<style lang="scss" scoped>
.frame-road {
  position: relative;
  overflow: hidden;
  .frame-bg {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    .frame-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      transition: transform 1s ease-in-out;
    }
    .img-overlay {
      object-fit: cover;
      position: absolute;
      height: 100%;
      min-height: 100vh;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      -webkit-transition: -webkit-filter 500ms linear;
      &.shadow {
        -webkit-filter: drop-shadow(0px 0px 1rem #ffeca6);
        filter: drop-shadow(0px 0px 1rem #ffeca6);
      }
    }
    .img-front {
      z-index: 3;
    }
  }
  .frame-content {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 33%);
    .frame-text {
      margin-bottom: 3rem;
      .bottom-line {
        border: 1px solid #f3e8d7;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
  .enter-door {
    color: #ffeec2;
    position: absolute;
    left: 53%;
    left: max(53%, 600px);
    top: 69%;
    transform: translateY(-50%);
    z-index: 5;
    text-decoration: none;
    font-size: 1rem;
    font-size: max(1rem, 18px);
    line-height: 20px;
    cursor: pointer;
    text-shadow: 0 0 10px black;
    border-bottom: 1px solid #ffeec2;
    @media (max-width: 576px) {
      left: 60%;
      top: 65%;
    }
    &:after {
      position: absolute;
      content: url("/assets/images/road-to.png");
      bottom: -1px;
      left: -31px;
      height: 76px;
      width: 13px;
    }
    &:hover {
      color: #fff !important;
    }
  }
  .zoom {
    transform: scale(3); /* (x * 100% zoom) */
  }
  .fade-out {
    opacity: 0;
    transition: opacity 0.5s linear;
  }
}
</style>
